import { ref } from 'vue';

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const open = ref(false);
const options = ref<ConfirmDialogOptions | null>(null);

/**
 * Module-level (singleton) state so any component can trigger the single
 * `<ConfirmDialog />` mounted in App.vue.
 */
export const useConfirmDialog = () => {
  const show = (dialogOptions: ConfirmDialogOptions) => {
    options.value = dialogOptions;
    open.value = true;
  };

  const confirm = () => {
    options.value?.onConfirm?.();
    open.value = false;
  };

  const cancel = () => {
    options.value?.onCancel?.();
    open.value = false;
  };

  return { open, options, show, confirm, cancel };
};
